// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3-Rtz","footer":"ModalCreateQualiphyProcedure_footer__1nOy6","additionData":"ModalCreateQualiphyProcedure_additionData__LLVXM"};